import { render, staticRenderFns } from "./NumberControl.vue?vue&type=template&id=4489b6d7"
import script from "./NumberControl.vue?vue&type=script&lang=js"
export * from "./NumberControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports